import { render } from "./AppListView.vue?vue&type=template&id=bfadec30"
import script from "./AppListView.vue?vue&type=script&lang=js"
export * from "./AppListView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__